export default function getAllInvoiceReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_ALL_INVOICE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_ALL_INVOICE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_ALL_INVOICE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}